import * as React from "react";
import logo from "../images/logos.png";

// UserInfo props
export interface IUserInfoProps {
    Name?: string,
    LoggedIn: boolean,
    LogIn: (uri?: string) => void,
    handleError: (e: any) => void,
    handleLogOut: () => void
}

// UserInfo view
export const UserInfo = (props: IUserInfoProps) =>
    <div className="userInfo">
        {
            !props.LoggedIn
                // tslint:disable-next-line:jsx-no-lambda
                ? <a className="button" href="#" onClick={e => {
                    e.preventDefault();
                    props.LogIn();
                }}>Logg på</a>
                : (!props.Name
                    ? <div>Henter brukerinfo...</div>
                    : <div>Logget på som {props.Name}<a className="button" href="#" onClick={props.handleLogOut}>Logg ut</a></div>)
        }
    </div>

export function Header(props: IUserInfoProps) {
    return <div className="header">
        <div className="brand"><img src={logo} /></div>
        <UserInfo {...props} />
    </div>;
}


// WEBPACK FOOTER //
// ./src/login/userinfo.tsx